import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectLogInUsername } from "../../../common/authenticateDashboard/authSlice";
import {
  graphSocialCounts,
  SelectWeeks,
} from "../../Main/components/TrafficSource/trafficSourceSlice";

const TopKTrafficSources = () => {
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
  const [topKUsers, setTopKUsers] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const weeks = useSelector(SelectWeeks);
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.trafficSource.data);
  console.log("user Data : " + JSON.stringify(userData));
  useEffect(() => {
    if (!user) return;
    if (weeks.length === 0) {
      dispatch(graphSocialCounts(user));
    } else {
      setDataLoaded(true);
    }
  }, [weeks, user, dispatch]);

  useEffect(() => {
    if (
      dataLoaded &&
      userData &&
      Array.isArray(userData) &&
      userData.length > 2
    ) {
      const userInfo = userData[0];
      const sourceNames = Object.keys(userInfo);
      const lastValues = sourceNames.map(
        (source) => userInfo[source][userInfo[source].length - 1]
      );

      const sortedLastValues = [...lastValues].sort((a, b) => b - a);

      const top3Sources = sortedLastValues.slice(0, 3).map((value) => {
        const index = lastValues.indexOf(value);
        return { sourceName: sourceNames[index], lastValue: value };
      });

      console.log("Top 3 sources with highest last values:", top3Sources);
      setTopKUsers(top3Sources);
    }
  }, [userData, dataLoaded]);

  return (
    <>
      {topKUsers.length > 0 ? (
        <div className="px-4 sm:px-6 lg:px-8 max-w-lg my-5">
          <div className="sm:flex sm:items-center">
            <h1 className="text-xl font-semibold leading-6 text-gray-900">
              Top K Users Traffic Sources 
            </h1>
          </div>
          <div className="mt-4 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <div className="overflow-hidden shadow ring-2 ring-black ring-opacity-5 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-gray-50">
                      <tr>
                        <th
                          scope="col"
                          className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                        >
                          Traffic Source  
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Number of Users
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {topKUsers.map((user, index) => (
                        <tr key={index}>
                          <td className="whitespace-nowrap py-3 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                            {user.sourceName}
                          </td>
                          <td className="whitespace-nowrap px-3 py-3 text-sm text-gray-500">
                            {user.lastValue}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center my-5">
          <p className="text-gray-900">No user data available for this week.</p>
        </div>
      )}
    </>
  );
};

export default TopKTrafficSources;
